['turbo:load', 'load'].forEach((e) => {
  window.addEventListener(e, () => {
    var selector = document.getElementById("phone_number");
    var im = new Inputmask("(999) 999-9999");
    if (selector) { im.mask(selector); }
  });
});
